module.exports = __webpack_public_path__ + "fonts/Beeline_Sans-Regular.53c84a9d.eot";